import React from 'react';
import Routes from './templates/index';
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from './ducks';
import { Provider } from 'react-redux';

const { store, persistor } = configureStore();

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Routes />
      </PersistGate>
    </Provider>
  );
}

export default App;
